/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:52:44
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-18 08:39:32
 * @FilePath: /dbrank_b/src/routes/visualChart/components/Wrapper/index.js
 * @Description: 公用一个公用盒子组件
 */
import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Button from '../Button';
import { convertCanvasToImage, saveFile } from '../../../../utils';

const BASE_SIZE = {
  width: 1280,
  height: 720,
}
class Stage extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    size: PropTypes.object,
    padding: PropTypes.string
  }
  screen = null;
  constructor(props) {
    super(props);
    let bgImg;
    let bgImgNum; // 页码
    if (global.window === global) {
      const pathname = global.document.location.pathname || '';
      bgImg = pathname.replace(/\D/g, '');
      bgImgNum = pathname.replace(/\D/g, '');
      try {
        bgImg = require(`./images/${bgImg}.png`);
      } catch(err) {
        bgImg = null;
      }
    }

    this.state = {
      bgImg,
      bgImgNum,
      visible: false,
      scale: 1,
      BASE_SIZE: props.size || BASE_SIZE,
      padding: props.padding || '20px  34px'
    }
  }
  toggle = () => {
    const { visible } = this.state;
    this.setState({ visible: !visible });
  }
  /**
   * 截图并下载
   */
  capture = () => {
    const { BASE_SIZE, scale } = this.state;
    const html2canvas = require('html2canvas')
    console.log(BASE_SIZE);
    html2canvas(this.screen, {
      // allowTaint: true,
      useCORS: true,
      foreignObjectRendering: true,
      scale: 2,
      width: BASE_SIZE.width * scale,
      height: BASE_SIZE.height * scale,
    })
      .then(canvas => {
        const src = convertCanvasToImage(canvas).src
        saveFile(src, `报告自动化-${location.pathname.split('').pop()}`)
      })
  }

  restore = () => {
    this.setState({ scale: 1 })
  }
  zoomOut = () => {
    const { scale } = this.state;

    if (scale > 0.5) {
      this.setState({ scale: scale - 0.1 })
    }
  }
  zoomIn = () => {
    const { scale } = this.state;
    
    if(scale < 3) {
      this.setState({ scale: scale + 0.1 })
    }
  }

  render() {
    const { BASE_SIZE, padding, bgImg, visible, scale, bgImgNum } = this.state;
    const _props = {
      // style: bgImg ? { backgroundImage: `url(${bgImg})` } : {}
    }
    return (
      <div className={s.root} {..._props} style={{ width:BASE_SIZE.width, height:BASE_SIZE.height}}>
        <div className={s.toolbox}>
          {/* <Button type="primary" onClick={this.toggle}>{visible ? '关闭模板' : '查看模板'}</Button> */}
          {/* <Button type="primary" onClick={this.zoomOut}>缩小-</Button> */}
          {/* <Button type="primary" onClick={this.restore}>还原</Button> */}
          {/* <Button type="primary" onClick={this.zoomIn}>放大+</Button> */}
          {/* <Button type="primary" onClick={this.capture}>截图</Button> */}
          {/* <Button type="primary" onClick={() => {
            window.open('https://www.shejidaren.com/examples/tools/color-scheme/', '_blank');
          }}>在线配色</Button> */}
        </div>

        {visible && (
          <div className={s.preview}>
            <img className={s.previewImg} src={bgImg} />
          </div>
        )}
        <stage></stage>
        <div
          style={{ width:BASE_SIZE.width, height:BASE_SIZE.height, padding: padding, transform: `scale(${scale})`,backgroundColor: (bgImgNum == 37 || bgImgNum == 38) ? '#000' : '#fff' }}
          className={s.viewContainer}
          ref={ele => this.screen = ele}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Stage);



// WEBPACK FOOTER //
// src/routes/visualChart/components/Stage/index.js